import React from 'react';
import PropTypes from 'prop-types';
import Tools from './Tools.jsx'

export default function Toolbar({
                              toolsProps
                            }) {
  return (
    <div>
      <Tools {...toolsProps} />
    </div>
  );
}

Toolbar.defaultProps = {};

Toolbar.propTypes = {
  filterProps: PropTypes.object,
  toolsProps: PropTypes.object
};





// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/Toolbar/index.jsx